import classNames from 'classnames';
import { FC, ReactElement } from 'react';
import styled from 'styled-components';

interface TopTabContentProps {
  className?: string;
  header: ReactElement;
  body: ReactElement;
  footer: ReactElement;
}

export const TopTabContent: FC<TopTabContentProps> = ({ className, header, body, footer }) => (
  <div className={classNames(className, 'd-flex flex-column')}>
    <div className="mt-3 px-3">{header}</div>
    <div className="flex-grow-1 flex-shrink-1 overflow-y-auto p-3">{body}</div>
    <Spacer className="flex-grow-1" />
    <div className="mx-3">{footer}</div>
  </div>
);

const Spacer = styled.em`
  height: 0;
`;
